export const environment = {
  production: false,
  identityPoolId: 'us-west-2:e80bc64c-7d05-4031-a9b6-4f7a00fe1ef6',
  userPoolId: 'us-west-2_vAwXkkeyy',
  webClientId: '59s6bqt6gjamnp0e3v1j3jk9mj',
  bucket: 'noe-free-qa',
  api: 'https://qwgzoz9s24.execute-api.us-west-2.amazonaws.com/free-qa/noe',
  apiCore: 'https://qwgzoz9s24.execute-api.us-west-2.amazonaws.com/free-qa/noe/core',
  xApiKey: 'vFT80sm9Ru3KhrMIYPjQJ8tepYDu7LB4twdRb0hh',
  captchaSiteKey:'6LfBENkaAAAAAP9qn7Z73BYMsrdvE-bfcZ92i7VX',
  reporteReplace: 'https://noe-free-qa.s3.amazonaws.com/',
  TESTING : false,
  rutaRegionQa:'https://noe-qa.s3.us-west-2.amazonaws.com',
  socketEndpoint:'wss://m272f6yx5k.execute-api.us-west-2.amazonaws.com/noefree-qa',
  domainAuth:'noe-free-qa.auth.us-west-2.amazoncognito.com',
  redirectSignIn:'https://indigital-free-qa.noe.pe/',
  redirectSignOut:'https://indigital-free-qa.noe.pe/',
  apiCoreUpload:'https://m3qjpdenk8.execute-api.us-west-2.amazonaws.com/free-qa/noe/core',
  xApiKeyUpload:'dP2mR5uYA78g9Oy3FB2ek4wei3HN2rRA7BOwhMuB',
  facebookAppId: '594053289432404',
  endPointSFClient: 'https://noe-free-qa.s3.us-west-2.amazonaws.com/SignFastClientV3',
  scriptNiubiz: 'https://static-content-qas.vnforapps.com/vTokenSandbox/js/checkout.js',
  passwordDecrypted : '#Noev3&pass'
};
